import React from "react";
import PropTypes from "prop-types";
import Page from "../../components/Page";

import CreateShiftTypeCompanyForm from "../../components/forms/CreateShiftTypeCompanyForm";

import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";

const CreateShiftTypeCompanyPage = (props) => (
  <Page enableGoBack title="Dienstsoortprijs voor bedrijf toevoegen">
    <CenteredPageContentContainer>
      <PaperContainer title="Dienstsoortprijs voor bedrijf toevoegen">
        <CreateShiftTypeCompanyForm
          shiftTypeId={props.match.params.shifttype_id}
        />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

CreateShiftTypeCompanyPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      shifttype_id: PropTypes.string.isRequired,
    }),
  }),
};

export default CreateShiftTypeCompanyPage;



// WEBPACK FOOTER //
// ./src/pages/ShiftTypeCompany/CreateShiftTypeCompanyPage.js